<div class="features-66 mt-2 pt-2 pb-0 section-gray">
  <div class="container">
    <div class="row">
      <div class="col-md-8 ml-auto mr-auto text-center">
        <h3 class="title font-weight-bold">PRACTICE MANAGEMENT SOFTWARE FOR BETTER PATIENT OUTCOMES</h3>
      </div>
    </div>
    <div class="row ml-auto mr-auto">
      <div class="col-12 col-lg-4 mt-lg-n2 ml-auto mr-auto ">
        <img class=" img-fluid img-responsive" alt="" src="./assets/img/website_2/image_13_3_steps-1.png">
      </div>
       <div class="col-12 col-lg-4 mt-lg-n2 ml-auto mr-auto ">
        <img class=" img-fluid img-responsive" alt="" src="./assets/img/website_2/image_13_3_steps-2.png">
      </div>
       <div class="col-12 col-lg-4 mt-lg-n2 ml-auto mr-auto ">
        <img class=" img-fluid img-responsive" alt="" src="./assets/img/website_2/image_13_3_steps-3.png">
      </div>
    </div>
  </div>
</div>


<div class="container mt-n1 justify-content-center mb-2"
  style="z-index: 900; position: absolute; left: 50%; transform: translateX(-50%);">
  <div class="row mt-n5 pb-4 p-3 mx-sm-0 mx-1 position-relative justify-content-center">


    <div class="col-lg-8 mt-lg-n2 mt-2 mb-2">
      <label class="">&nbsp;</label>
      <button type="button" class="btn btn-sm btn-danger w-100 mb-0" [routerLink]="['/get-a-quote']"> Get A Quote
      </button>
    </div>
  </div>
</div>